import React, { Component } from "react";
import GenberCode from "../genberCode";
import emsLogoV2 from "../../../Assets/images/logo/emsLogoV2.png";

export default class FormatLabelAddressPornor extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        style={{
          fontFamily: "Kanit",
          fontSize: "13px",
          position: "relative",
          marginTop: "1px",
          marginBottom: "1px",
        }}
        className="page-break"
      >
        <div style={{ paddingTop: "60px" }}>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <div>
              <div style={{ marginLeft: "10px" }}>
                <b>ชื่อที่อยู่ผู้รับ</b>
              </div>
            </div>
            <div>
              <div style={{ marginRight: "20px" }}>{"Test"}</div>
            </div>
          </div>
          <div style={{ marginLeft: "10px" }}>
            {this.props.supplies.receiver_name}&nbsp;&nbsp;Tel :&nbsp;&nbsp;{this.props.supplies.receiver_phone}
          </div>
          <div style={{ marginLeft: "10px" }}>{this.props.supplies.receiver_address}</div>
          <div style={{ marginLeft: "10px" }}>
            {this.props.supplies.receiver_amphur}&nbsp;&nbsp;{this.props.supplies.receiver_province}
          </div>
          <div style={{ marginLeft: "10px" }}>{this.props.supplies.receiver_zipcode}</div>
          <br />
          <div style={{ marginLeft: "10px" }}>
            <b>ชื่อที่อยู่ผู้ฝากส่ง</b>
          </div>
          <div style={{ marginLeft: "10px" }}>
            {this.props.supplies.sender_name}&nbsp;&nbsp;Tel :&nbsp;&nbsp;{this.props.supplies.sender_phone}
          </div>
          <div style={{ marginLeft: "10px" }}>{this.props.supplies.sender_address}</div>
          <div style={{ marginLeft: "10px" }}>
            {this.props.supplies.sender_amphoe}&nbsp;&nbsp;{this.props.supplies.sender_province}
          </div>
          <div style={{ marginLeft: "10px" }}>{this.props.supplies.sender_zipcode}</div>
          <br />
          <div style={{ border: "2px solid #000", textAlign: "center", marginLeft: "20px", marginRight: "20px" }}>
            <label style={{ fontSize: "10px" }}>บริการจัดส่งสินค้าเพื่อธุรกิจ e-Commerce (บริการ e-Parcel)</label>
            <br />
            <label>
              ใบอนุญาติสำหรับลูกค้าธุรกิจ <b>เลขที่ ขล. 18/2564</b>
            </label>
            <br />
            <label style={{ fontSize: "10px" }}>ชำระค่าบริการตามที่ ปณท กำหนด</label>
          </div>
          <div style={{ textAlign: "center", marginTop: "5px" }}>
            {parseInt(this.props.supplies.cod_cost) !== 0 ? (
              <b>EMS COD :&nbsp;&nbsp;{parseInt(this.props.supplies.cod_cost).toLocaleString()}&nbsp;&nbsp;บาท</b>
            ) : (
              ""
            )}
          </div>
          <div style={{ textAlign: "center", marginTop: "5px" }}>
            <GenberCode awbCode={this.props.supplies.awb_code} />
          </div>
          <div style={{ justifyContent: "space-between", display: "flex" }}>
            <div>
              <b style={{ fontSize: "15px" }}>&nbsp;&nbsp;DROP OFF</b>
            </div>
            <div>
              <img alt="" src={emsLogoV2} width="120" height="30" className="d-inline-block align-top" />
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  }
}
